import { debounce } from 'lodash';
import React, { useEffect, useState } from 'react';
const useSearch = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const debouncedSearch = React.useRef(
    debounce(async (criteria) => {
      setSearchValue(criteria);
    }, 0.5),
  ).current;
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);
  const onSearch = (input: string | React.ChangeEvent<HTMLInputElement>) => {
    const value = typeof input === 'string' ? input : input.target.value;
    debouncedSearch(value);
  };
  return { searchValue, onSearch, setSearchValue };
};
export default useSearch;
